import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CloseDialog, OpenDialog, PostComment, PostRating, SetRating } from './rating.actions';
import { RatingState } from './rating.state';
import { Record } from 'src/app/models/record';

@Injectable({
  providedIn: 'root'
})
export class RatingDialogFacade {
  private readonly store = inject(Store);

  @Select(RatingState.open) open$: Observable<boolean>;
  @Select(RatingState.userVote) userVote$: Observable<number>;
  @Select(RatingState.hasUserVoted) hasUserVoted$: Observable<boolean>;

  openDialog(record: Record) {
    this.store.dispatch(new OpenDialog(record));
  }

  postComment(comment: string) {
    return this.store.dispatch(new PostComment(comment));
  }

  postRating() {
    return this.store.dispatch(new PostRating());
  }

  setRating(rate: number) {
    this.store.dispatch(new SetRating(rate));
  }

  closeDialog() {
    this.store.dispatch(new CloseDialog());
  }
}
